export default __webpack_public_path__ + "static/seoul_fintech_lab-d49cb35a73ea36168d5d663c084d74ce.png";